class Accordion {

  constructor(el) {
    this.el = el
    this.listen()
  }

  listen() {
    this.el.addEventListener('click', (ev) => {
      const openEl = this.el.querySelector('.accordion__button--open')
      if (ev.target.classList.contains('accordion__button')) {
        if (openEl) {
          this.closeRow(openEl)
        }
        if (openEl != ev.target) {
          this.openRow(ev.target)
        }
        if (openEl == ev.target) {
          this.closeRow(ev.target)
        }
      }
    })
  }

  closeRow(element) {
    element.nextElementSibling.style.maxHeight = "0"
    element.classList.remove('accordion__button--open')
  }

  openRow(element) {
    element.classList.add('accordion__button--open')
    element.nextElementSibling.style.maxHeight = element.nextElementSibling.scrollHeight + "px"
  }
}

export default Accordion